<template>
  <div>
    <div class="home-header">
      <div class="container">
        <el-row type="flex" align="bottom" :gutter="24" class="row-bg" v-if="$store.state.userInfo.role !== 2">
          <el-col :span="4">
            <div class="grid-content bg-purple" @click="tohome">
              <img src="../../assets/img/index-logo.jpg" alt="" />
            </div>
          </el-col>
          <el-col :span="8">
            <div class="header-menu">
              <div class="item-menu">
                <span @click="tohome">首页</span>
              </div>
              <div class="item-menu">
                <span @click="account">用户中心</span>
              </div>
              <div class="item-menu">
                <span @click="batchOrder">批量下单</span>
              </div>
              <div v-if="$store.state.userInfo.userNumber < 0" class="item-menu">
                <span @click="bookdown">书目下载</span>
              </div>
              <div class="item-menu">
                <span @click="company">公司介绍</span>
              </div>
            </div>
          </el-col>
          <el-col :span="12" class="row-search" v-if="$store.state.userInfo.role !== 2">
            <div class="grid-content bg-purple">
              <el-input placeholder="输入你想查找的内容" v-model="inputval" class="input-with-select" @keyup.enter.native="productList">
                <el-select style="width: 120px" v-model="selectval" slot="prepend" placeholder="请选择" @change="selectvalChange">
                  <el-option v-for="item in liitem" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-button slot="append" @click="productList" @keyup.enter.native="productList" icon="el-icon-search">搜索</el-button>
              </el-input>
            </div>
          </el-col>
        </el-row>
        <el-row type="flex" align="bottom" :gutter="24" class="row-bg" v-if="$store.state.userInfo.role === 2">
          <el-col :span="4">
            <div class="grid-content bg-purple" @click="tohome1">
              <img src="../../assets/img/index-logo.jpg" alt="" />
            </div>
          </el-col>  
          <el-col :span="10" v-if="checkWhMember">
            <div class="header-menu">
              <div class="item-menu">
                <span @click="batchWHOrder">批量查单</span>
              </div>
              <div class="item-menu">
                <span @click="whBookDown">书目下载</span>
              </div>
            </div>
          </el-col>
          <!-- <el-col :span="2">
            <el-checkbox-group v-model="selectOptionList" @change="selectOpWHChange">
              <el-checkbox v-for="(item, index) in whSelectOptions" :label="item.value" :key="index">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
          </el-col> -->
          <el-col :span="10" class="row-search">
            <div class="grid-content bg-purple">
              <el-input placeholder="输入你想查找的内容" v-model="wh.inputval" class="input-with-select" @keyup.enter.native="productWHList">
                <el-select clearable style="width: 120px" v-model="wh.selectval" slot="prepend" placeholder="请选择" @change="selectvalWHChange">
                  <el-option v-for="item in liitem" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-button slot="append" @click="productWHList" @keyup.enter.native="productWHList" icon="el-icon-search">搜索</el-button>
              </el-input>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
// fade/zoom 等
import "element-ui/lib/theme-chalk/base.css";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      show: false,
      showSearchList: false,
      headerNav: [],
      currentIndex: null,
      time: null,
      seachvalue: "",
      liitem: [
        { label: "搜索全部", value: "1" },
        { label: "图书名称", value: "2" },
        { label: "作者", value: "3" },
        { label: "ISBN", value: "4" },
        { label: "出版社", value: "5" },
      ],
      // whSelectOptions: [
      //   {
      //     value: 'wh-self', label: '自己上传'
      //   }, {
      //     value: 'system', label: '系统上传'
      //   }
      // ],
      // selectOptionList: this.$store.state.selectOptionHbList,
      inputval: "",
      selectval: "1",
      wh:{
        inputval: "",
        selectval: "1",
      },
        
    };
  },
  created () {
  },
  computed: {
    ...mapGetters(["isNaName", "checkWhMember"]),
  },
  mounted () {
  },
  methods: {
  //   selectOpWHChange(val) {
  //     // console.log("供应商选择搜索框val :>> ", val, this.wh.selectOptionList);
  //     this.$store.commit("set_selectOptionHbList", val);
  //   },
    selectvalWHChange(val) {
      console.log("供应商搜索框val :>> ", val, this.wh.selectval);
      // this.wh.selectval = val;
    },
    whBookDown(){
      // this.$store.commit("hasLogin");
      this.getHasLogin(1);
      if (!this.isNaName) {
        this.$router.push("/provider/bookDown");
      } else {
        this.tologin1();
      }
    },
    batchWHOrder(){
      // this.$store.commit("hasLogin");
      this.getHasLogin(1);
      if (!this.isNaName) {
        this.$router.push("/provider/whBatchOrder");
      } else {
        this.tologin1();
      }
    },
    productWHList() {
      const that = this
      // this.$store.commit("hasLogin");
      this.getHasLogin(1);
      if (!this.isNaName) {
        that.$router.push({
          params: {
            selectval: that.wh.selectval,
            inputval: that.wh.inputval.replace(/\s+/g, ""),
            dt: new Date().getTime(),
          },
          name: "供应商图书列表",
        });
      } else {
        this.tologin1();
      }
    },
    onfocus() {
      this.$refs.searchPart.className += " foucs";
      this.$refs.btn.className = "foucs";
      this.showSearchList = true;
    },
    onblur() {
      this.time = setTimeout(() => {
        this.$refs.searchPart.className = "searchPart";
        this.$refs.btn.className = "";
        this.showSearchList = false;
      }, 100);
    },
    goSearchResult() {
      clearTimeout(this.time);
      this.$router.push("/search");
      this.showSearchList = false;
    },
    tohome() {
      this.$router.push("/home");
    },
    tohome1() {
      // this.$store.commit("hasLogin");
      this.getHasLogin(1);
      if (!this.isNaName) {
      this.$router.push("/provider/accountInfo");
      } else {
        this.tologin1();
      }
    },
    bookdown() {
      // this.$store.commit("hasLogin");
      this.getHasLogin(0);
      if (!this.isNaName) {
        this.$router.push("/bookList");
      } else {
        this.tologin();
      }
    },
    account() {
      // this.$store.commit("hasLogin");
      this.getHasLogin(0);
      if (!this.isNaName) {
        this.$router.push("/user/personal");
      } else {
        this.tologin();
      }
    },
    company() {
      this.$router.push("/company");
    },
    batchOrder() {
      // this.$store.commit("hasLogin");
      this.getHasLogin(0);
      if (!this.isNaName) {
        this.$router.push("/batchOrder");
      } else {
        this.tologin();
      }
    },
    productList() {
      // this.$store.commit("hasLogin");
      this.getHasLogin(0);
      if (!this.isNaName) {
        let selectval = this.selectval;
        this.inputval = this.inputval.replace(/\s+/g, "");
        let inputval = this.inputval;
        this.$router.push({
          params: {
            selectval: selectval,
            inputval: inputval,
            dt: new Date().getTime(),
          },
          name: "图书列表",
        });
      } else {
        this.tologin();
      }
    },
    selectvalChange(val) {
      console.log("搜索框val :>> ", val);
      this.selectval = val;
    },
    tologin() {
      this.$message({
        message: "请先登录！",
        type: "warning",
      });
      this.$router.push("/login");
    },
    tologin1() {
      this.$message({
        message: "请登录供应商身份账号！",
        type: "warning",
      });
      this.$router.push("/loginProvider");
    },
    getHasLogin(){
      if(this.$store){
        this.$store.commit("hasLogin");
        return true;
      }
      return false;
    }
  },
  components: {},
};
</script>

<style lang="scss" scoped>
$mainColor: #5cadff;

.foucs {
  border-color: $mainColor !important;
}
.blur {
  border-color: #e0e0e0 !important;
}
.home-header {
  width: 100%;
  position: relative;
  background-color: #fff;
  border-bottom: 1px solid #5cadff;
  height: 100px;
  .header-logo {
    float: left;
    margin-top: 15px;
    overflow: hidden;
    ul {
      width: 200%;
      transition: all ease 0.2s 0s;
      li {
        a {
          float: left;
          width: 55px;
          height: 55px;
          color: #fff;
          text-align: center;
          span {
            line-height: 55px;
            font-size: 30px;
          }
        }
      }
    }
    &:hover {
      ul {
        transform: translateX(-50%);
      }
    }
  }
  .header-search {
    margin-top: 25px;
    margin-bottom: 25px;
    float: right;
    form {
      position: relative;
      .searchPart {
        float: left;
        width: 245px;
        height: 50px;
        transition: all linear 0.2s 0s;
        border: 1px solid #e0e0e0;
        border-right: 0;
        box-sizing: border-box;
        input {
          width: calc(100% - 10px);
          height: 100%;
          outline: none;
          padding: 0 0 0 10px;
          &::-webkit-input-placeholder {
            color: #757575;
          }
        }
      }
      &:hover {
        .searchPart {
          border-color: #b0b0b0;
        }
        .sumbitPart {
          button {
            border-color: #b0b0b0;
          }
        }
      }
      .sumbitPart {
        float: left;
        button {
          cursor: pointer;
          width: 50px;
          height: 50px;
          border: 1px solid #e0e0e0;
          box-sizing: border-box;
          background-color: #fff;
          transition: all linear 0.2s 0s;
          span {
            color: #616161;
            font-size: 20px;
          }
        }
        &:hover {
          button {
            background-color: $mainColor;
            border: 1px solid $mainColor;
            span {
              color: #fff;
            }
          }
        }
      }
    }
  }
  .header-menu {
    .item-menu {
      display: inline-block;
      color: #333333;
      font-family: bold;
      font-size: 1.6em;
      line-height: 35px;
      margin-right: 20px;
      span {
        //小手
        cursor: pointer;
      }
      &:hover {
        color: #409eff;
        .children {
          height: 220px;
          //默认高度为0
          height: 1;
          //默认透明度为0
          opacity: 1;
          background: #fff;
        }
      }
    }
  }
  .header-nav {
    height: 100px;
    margin-left: 235px;
    > ul {
      line-height: 100px;
      > li {
        float: left;
        height: 100px;
        padding: 0 10px;
        a {
          span {
            transition: all linear 0.15s 0s;
            color: #333333;
            font-size: 16px;
          }
          .item-children {
            width: 100%;
            position: absolute;
            z-index: 999;
            top: 100px;
            left: 0;
            box-shadow: 0 3px 4px rgba(0, 0, 0, 0.1);
            .transition-box {
              width: 100%;
              height: 230px;
              background-color: #fff;
              text-align: center;
              box-sizing: border-box;
              border-top: 1px solid #e0e0e0;
              ul {
                li {
                  width: calc(100% / 6);
                  float: left;
                  a {
                    .figure {
                      width: 100%;
                      border-right: 1px solid #e0e0e0;
                      margin-top: 35px;
                      height: 110px;
                      margin-bottom: 20px;
                      img {
                        display: inline-block;
                        width: 160px;
                        height: 110px;
                      }
                    }
                    .title {
                      line-height: 20px;
                      font-size: 12px;
                      color: #333;
                    }
                    .price {
                      line-height: 20px;
                      font-size: 12px;
                      color: $mainColor;
                    }
                  }
                  &:last-child {
                    a {
                      .figure {
                        border-right: 0;
                      }
                    }
                  }
                }
              }
            }
          }
          &:hover {
            span {
              color: $mainColor;
            }
          }
        }
      }
    }
  }
}
</style>
